<template>
    <div class="booking-wizard-footer">
        <div class="row" style="gap: 1em">
            <template v-if="prevStep">
                <!-- TODO: Font awesome icon: 'fas', 'times' -->
                <button class="button max-w-[10em]" @click="reset">{{ i18n.t('navigation.quit') }}</button>
            </template>
            <div v-if="showNavigationGuide" class="nav-guide">
                {{ i18n.t('navigation.guide', { phone_number: activeAccount?.information.phoneNumber ?? '' }) }}
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { storeToRefs } from 'pinia';
import { useMetadataStore } from '@/widgets/Wizard/stores/metadata';
import { useStepsStore } from '@/widgets/Wizard/stores/steps';

const i18n = useI18n();

const { activeAccount } = useMetadataStore();

const showNavigationGuide = computed(() => activeAccount?.options.showNavigationGuide ?? true);

const stepsStore = useStepsStore();
const { reset } = stepsStore;
const { prevStep } = storeToRefs(stepsStore);
</script>
